/** Compte plateforme HubUP (permission admin). */
export function isHubupPlatformAdmin(user) {
  return user?.permission === 'admin';
}

/** Accès HubUP à au moins une communauté (notifications, rubriques…). */
export function hasHubupCommunityAccess(user) {
  if (!user) return false;
  if (isHubupPlatformAdmin(user)) return true;
  return user.hubup === true;
}

/** Gestion Hubup : profil public, bienvenue, QR/RA, annuaire. */
export function canManageHubupCommunitySettings(user) {
  if (!user) return false;
  if (isHubupPlatformAdmin(user)) return true;
  return user.hubup === true && user.hubupManager === true;
}
